import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { GetOrganizerResponse, ICategorization, IConvertDateTimeToUTCReq, IConvertDateTimeToUTCResp, IGetApptInfoFromItemId, IICalUidExternal, OrganizationInfo } from "./entity/OrganizationEntity";

export const TokenIOrganizationService = "IOrganizationService";

export interface IOrganizationService {
  fetchOrgInfo(): Promise<HttpResponse<OrganizationInfo>>;
  fetchCategorization(tenantId: string, orgId: string): Promise<HttpResponse<ICategorization>>;
  GetCurrentOrganizer(org?: OrganizationInfo | null): Promise<GetOrganizerResponse | undefined>
  GetCurrentOutlookUser() : GetOrganizerResponse | undefined;
  getAppInfoByItemId(url: string, accessToken: string): Promise<HttpResponse<IGetApptInfoFromItemId>>;
  getICalUidExternal(tenantId: string, orgId: string, uid: string): Promise<SearchResponse<IICalUidExternal>>;
  convertDateTimeToUTC(req: IConvertDateTimeToUTCReq): Promise<HttpResponse<IConvertDateTimeToUTCResp>>
}
